import { ENV } from '@components/Environment.js';
import DIContainer from '@components/DependencyInjectionContainer.js';
import { DateTimeManager } from '@components/DateTimeManager/DateTimeManager.js';
export function formatIconByColumnDef(value, columnDef) {
    // for now we dont care about the value, we just want the icon from the columndef.
    // eventually we will most likely need to support more dynamic icon scenarios 
    let icon = columnDef.icon;
    if (icon === 'comment' && !value) {
        icon = 'mode_comment';
    }
    const iconManager = DIContainer.resolve('IconManager');
    const iconElement = iconManager.getIconElement(icon);
    return iconElement;
}
export function formatCheckboxByColumnDef(value, columnDef) {
    // if value is Y, checkbox is checked.
    let checkedValue = 'Y';
    if (columnDef.editorProperties) {
        checkedValue = columnDef.editorProperties?.checkedValue || checkedValue;
    }
    const iconManager = DIContainer.resolve('IconManager');
    const checkboxElement = iconManager.getIconElement(value === checkedValue ? 'checkbox' : 'checkbox_empty');
    return checkboxElement;
}
export function formatRadioByColumnDef(value, columnDef) {
    let checkedValue = 'Y';
    if (columnDef.editorProperties) {
        checkedValue = columnDef.editorProperties?.checkedValue || checkedValue;
    }
    const iconManager = DIContainer.resolve('IconManager');
    const checkboxElement = iconManager.getIconElement(value === checkedValue ? 'radio_button_checked' : 'radio_button_unchecked');
    return checkboxElement;
}
// Helper function to ensure single-digit days or months have a leading zero
// function pad(n: number): string {
// 	return n < 10 ? '0' + n : n.toString();
// }
export function formatDateByColumnDef(value, _columnDef) {
    if (!value) {
        return '';
    }
    const date = DateTimeManager.parseDateTime(value);
    return date.toFormat(ENV('dateFormat'));
}
export function formatDatetimeByColumnDef(value, columnDef, sourceTimezone = 'SYSTEM', destinationTimezone = 'USER') {
    if (!value) {
        return '';
    }
    return DateTimeManager.formatDateTime(value, ENV('datetimeFormat'), sourceTimezone, destinationTimezone);
}
export function formatNumericByColumnDef(value, columnDef) {
    if (typeof value === 'string' && value.trim() === '') {
        return '';
    }
    const numericValue = parseFloat(value.toString());
    const formattedValue = numericValue.toFixed(columnDef.decimals || 0);
    const decimalSymbol = ENV('numberDecimal');
    const separatorSymbol = ENV('numberThousandSeparator');
    // Split the formatted value into integer and decimal parts
    const parts = formattedValue.split('.');
    // Add thousands separator to the integer part
    const integerPartWithSeparator = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, separatorSymbol);
    // Rejoin the integer and decimal parts, replacing the decimal point if necessary
    const finalValue = parts.length > 1
        ? `${integerPartWithSeparator}${decimalSymbol}${parts[1]}`
        : integerPartWithSeparator;
    return finalValue;
}
export function formatMoneyByColumnDef(value, columnDef, symbol = '') {
    if (typeof value === 'string' && value.trim() === '') {
        return '';
    }
    const numericValue = parseFloat(value.toString());
    const formattedValue = numericValue.toFixed(columnDef.decimals || 0);
    const decimalSymbol = ENV('numberDecimal');
    const separatorSymbol = ENV('numberThousandSeparator');
    // Split the formatted value into integer and decimal parts
    const parts = formattedValue.split('.');
    // Add thousands separator to the integer part
    const integerPartWithSeparator = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, separatorSymbol);
    // Rejoin the integer and decimal parts, replacing the decimal point if necessary
    const finalValue = parts.length > 1
        ? `${integerPartWithSeparator}${decimalSymbol}${parts[1]}`
        : integerPartWithSeparator;
    return `${symbol}${finalValue}`;
}
export function formatStringByColumnDef(value, _columnDef) {
    return value;
}
export function round(value, decimals) {
    if (typeof value === 'string') {
        value = Number(value);
    }
    return Number(value.toFixed(decimals));
}
